import React from 'react';

import type {
  IResourceAnnouncementItem,
  IResourceDocumentItem,
  IResourceItemType,
  IResourceLinkItem,
} from '@/api/types';

import { getResourceItemType } from '@/helpers';
import { AnnouncementPreview, DocumentPreview, LinkPreview } from '.';

interface ISimpleResourcePreviewBodyProps {
  resource: IResourceItemType;
}

const SimpleResourcePreviewBody = ({ resource }: ISimpleResourcePreviewBodyProps): React.ReactElement => {
  switch (getResourceItemType(resource)) {
    case 'document':
      return <DocumentPreview resource={resource as IResourceDocumentItem} />;
    case 'announcement':
      return <AnnouncementPreview resource={resource as IResourceAnnouncementItem} />;
    case 'link':
      return <LinkPreview resource={resource as IResourceLinkItem} />;
    default:
      return <></>;
  }
};

export { SimpleResourcePreviewBody };
